import Controller from "csi/action/Controller";
import FormData from "csi/action/FormData";
import { Context } from "csi/def/Context";
import locale from "csi/locale";
import csi from "csi/main";
import { ViewWidget } from "csi/view/Widget";
import { WizardWidget } from "csi/wizard/Widget";
import Content from "csi/tabs/Content";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import _ from "csi/_base/underscore";
import declare from "dojo/_base/declare";

const MassAddFormulatedMaterial = declare([Controller, ActionControllerMixin], {
	_operation: "AddRecipeLineItemFromFormulatedMaterial",
	successMsg: "",

	FIELD_TARGET_PRODUCT_TYPE: "ProductType",

	getFormData() {
		const fd = this.inherited<FormData>(arguments);
		fd.m_bRequireOne = true;
		return fd;
	},

	getWizardViewQuery(wizard: WizardWidget, view: ViewWidget, index: Number): Query {
		let q: Query;

		if (index == 0) {
			q = this.inherited<Query>(arguments);
		} else if (index == 1) {
			const foodSubtype = this.m_formData.getFieldValue("FoodSubtype");
			const formulatedMaterialSubtype = this.m_formData.getFieldValue("FormulatedMaterialSubtype");
			const productField = this.m_formData.getFieldValue(this.FIELD_TARGET_PRODUCT_TYPE);
			const recipeSubtypeField = this.m_formData.getFieldValue("RecipeDataSheetSubtype");

			const isFoodSubtype = productField === locale.type("Food");
			const subtype = isFoodSubtype ? foodSubtype : formulatedMaterialSubtype;

			q = new Query();
			q.RefAttr("Subtype", xml.OP_EQUALS, subtype, "Child:__Parent__/Child:__Parent__");

			if (recipeSubtypeField != csi.EMPTY_URL) {
				q.RefAttr("Subtype", xml.OP_EQUALS, recipeSubtypeField, "Child:__Parent__");
			}
		}
		return q;
	},

	onNextPage(wizard: WizardWidget, currentPage: Content, nextPage: Content, bFinish: Boolean) {
		// summary: prepare the data and pass it into the next page
		return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
	},

	onWizardViewCreate(wizard: WizardWidget, page: Content, view) {
		// summary: notify when view created for page
		const index = wizard.getIndexOfPage(page);
		if (index == 0) {
			view.addFixedValue(view.FIELD_MATERIAL_NAME, this.getParent().$Name);
		}
	},

	postProcessSuccess() {
		this.inherited(arguments);
		const fd = this.m_formData;
		const numCreated = fd.getSelectedValue().length;

		const resource = "MassAddFormulatedMaterial_Success";
		this.successMsg = locale.resource(resource, [numCreated]);
	},

	getSuccess() {
		return this.successMsg;
	},

	toWriter() {
		const fd = this.m_formData;
		const callList = this.m_writer.callList("FormulatedProduct", this._operation, fd.getSelectedValue(), xml.PROP_URL);
		callList.addParameter("FromURL", xml.ATTR_REF, this.m_urlParent);

		_.forEach(fd.getFields(), (field) => {
			const fieldId = field.m_id;
			if (fieldId && !field.m_bUsed) {
				callList.addGeneralizedParameter(fieldId, field.getType(), field.getValue());
				field.m_bUsed = true;
			}
		}, this);
	},

	/**
	 * If the user does not have edit access then it is displayed but is not selectable.
	 */
	_canAggregateNode(ctx: Context, fd: FormData) {
		return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
	},

});

export = MassAddFormulatedMaterial;